import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { API_BASE } from "@/lib/utils";
import { keys } from "./keys";

/** The org's company domain: the one confirmed at onboarding, else the org's own. Null when neither is set. */
export function useOrgDomain() {
  const { userContext } = useAuth();
  const orgId = userContext?.orgId;
  return useQuery<string | null>({
    queryKey: keys.onboarding.orgDomain(orgId),
    queryFn: async () => (await apiFetch<{ domain: string | null }>(`${API_BASE}/v1/me/org-domain`)).domain ?? null,
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
